import { render, staticRenderFns } from "./MoneyForbidChart.vue?vue&type=template&id=3da0b6d2&scoped=true&"
import script from "./MoneyForbidChart.vue?vue&type=script&lang=js&"
export * from "./MoneyForbidChart.vue?vue&type=script&lang=js&"
import style0 from "./MoneyForbidChart.vue?vue&type=style&index=0&id=3da0b6d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da0b6d2",
  null
  
)

export default component.exports